export default "<div [@foobar]=\"state\">\r\n    <ng-content></ng-content>\r\n</div>"